import RestrictedUserRoute from "discourse/routes/restricted-user";
export default class PreferencesApps extends RestrictedUserRoute {}